import React, { FC, MouseEvent } from 'react';

import { Modal } from 'antd';

// Shared UI Library Components
import { CustomButton } from '@ppmcore/seven-ppm-core-shared-components-react';

// Styles
import './same-counsellor-email-modal.scss';

type TDeleteSessionModalProps = {
  open: boolean;
  onCancel?: () => void;
  onOk?: () => void;
}

export const SameCounsellorEmailModal: FC<TDeleteSessionModalProps> = (
  {
    open = false,
    onCancel = () => {},
    onOk = () => {},
  }: TDeleteSessionModalProps
) => {

  const handleCancel = (_: MouseEvent<HTMLButtonElement>): void => {
    onCancel();
  };

  const handleSubmit = async (): Promise<void> => {
    onOk();
  }

  return (
    <Modal
      rootClassName="same-counsellor-email-modal"
      width={ '500px' }
      open={ open }
      maskClosable={ false }
      centered={ true }
      closeIcon={ false }
      title={ 'The email you provided is the primary identifier for your profile. Would you also like to use it to create a Consultant account?' }
      footer={ [
        <CustomButton key="no" text={ 'No' } type={ 'text' } onClick={ handleCancel }/>,
        <CustomButton key="yes" text={ 'Yes' } onClick={ handleSubmit }/>
      ] }
      onCancel={ handleCancel }
    />
  )
};
